export default function TextHero({ children }: { children: React.ReactNode }) {
    return (<>
        <h1 className="text-hero">
            {children}
        </h1>
    </>)
}